$(document).on("change", ".voting", function() {
  if ($(this)[0].checked) {
    $(".with_voting").addClass("d-block").removeClass("d-none")
    $(".without_voting").addClass("d-none").removeClass("d-block")
  } else {
    $(".with_voting").addClass("d-none").removeClass("d-block")
    $(".without_voting").addClass("d-block").removeClass("d-none")
  }
})

function disableCategoryInputs(container) {
  container.addClass("d-none")
  container.find("input, select, textarea").each(function() {
    var $el = $(this)
    if ($el.attr("name")) {
      $el.data("original-name", $el.attr("name"))
    }
    $el.removeAttr("name")
    $el.prop("disabled", true)
  })
}

function enableCategoryInputs(container) {
  container.removeClass("d-none")
  container.find("input, select, textarea").each(function() {
    var $el = $(this)
    var originalName = $el.data("original-name")
    if (originalName) {
      $el.attr("name", originalName)
    }
    $el.prop("disabled", false)
  })
}

toggle_webinar_category = function() {
  let category = $("#webinar_category").val()

  $(".topic-container").addClass("d-none").removeClass("d-block")
  $(".available-places-content").removeClass("d-none").addClass("d-block")

  disableCategoryInputs($(".additional-webinar-content"))
  disableCategoryInputs($(".exchange-webinar-content"))
  disableCategoryInputs($(".added_value-webinar-content"))
  disableCategoryInputs($(".open_exchange-webinar-content"))

  enableCategoryInputs($("." + category + "-webinar-content"))

  if (category == "open_exchange") {
    disableCategoryInputs($(".moderator-content"))
    $(".recording-content").addClass("d-none")
    // vorherigen Wert einmalig sichern, dann auf "none" erzwingen (moderatorenlos, keine Aufzeichnung)
    $(".recording-content select").each(function() {
      var $el = $(this)
      if ($el.data("prev-recording") === undefined) {
        $el.data("prev-recording", $el.val())
      }
      $el.val("none")
    })
  } else {
    enableCategoryInputs($(".moderator-content"))
    $(".recording-content").removeClass("d-none")
    // beim Zurueckschalten den gemerkten Wert wiederherstellen (sonst bliebe das Seminar still auf "none")
    $(".recording-content select").each(function() {
      var $el = $(this)
      var prev = $el.data("prev-recording")
      if (prev !== undefined) {
        $el.val(prev)
        $el.removeData("prev-recording")
      }
    })
  }

  if (category == "additional") {
    $(".topic-container").removeClass("d-none").addClass("d-block")
  }

  if (category == "added_value") {
    $(".available-places-content").addClass("d-none").removeClass("d-block")
    $(".available-places-content input").val(500)
  }
}

$(document).on("change", "#webinar_category", toggle_webinar_category)

document.addEventListener("initialize", toggle_webinar_category)

$(document).on('change', '.update-cost-data', function() {
  let data = $(this).data('cost-data')
  let cost_unit = data[$(this).val()]["cost_unit"]
  let cost_center = data[$(this).val()]["cost_center"]

  $('.cost_unit').val(cost_unit)
  $('.cost_center').val(cost_center)
})
